export const WALLET_BALANCE_QUERY = "wallet.balance.v1";
export const PAYMENT_HISTORY_QUERY = "payments.history.v1";
export const L402_HISTORY_QUERY = "l402.history.v1";
export function createWalletBalanceQuery(service) {
    return {
        invalidateOn: ["domain.entity-changed", "outbox.state-changed", "sync.delta-applied"],
        key: () => "wallet-balance",
        name: WALLET_BALANCE_QUERY,
        run: async (params) => {
            parseEmptyParams(params);
            return [await service.readBalance()];
        },
    };
}
export function createPaymentHistoryQuery(service) {
    return {
        invalidateOn: ["domain.entity-changed", "outbox.state-changed", "sync.delta-applied"],
        key: () => "payment-history",
        name: PAYMENT_HISTORY_QUERY,
        run: async (params) => {
            parseEmptyParams(params);
            return [await service.listPayments()];
        },
    };
}
export function createL402HistoryQuery(service) {
    return {
        invalidateOn: ["domain.entity-changed", "outbox.state-changed", "sync.delta-applied"],
        key: () => "l402-history",
        name: L402_HISTORY_QUERY,
        run: async (params) => {
            parseEmptyParams(params);
            return [await service.listL402Receipts()];
        },
    };
}
function parseEmptyParams(value) {
    if (value === null || typeof value !== "object" || Array.isArray(value) || Object.keys(value).length !== 0) {
        throw new TypeError("Wallet queries do not accept parameters");
    }
}
//# sourceMappingURL=wallet.js.map